<!-- eslint-disable prettier/prettier -->
<div class="min-h-screen bg-gray-50 text-gray-900 font-sans flex flex-col">
  <!-- Header -->
  <header class="bg-white border-b border-gray-200 sticky top-0 z-20 shadow-sm">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
      <!-- Autres pages : header standard avec nav -->
      <div class="flex items-center gap-8">
        <div class="flex items-center gap-3 cursor-pointer" (click)="navigateTo('/home')">
          <div class="bg-blue-600 p-2 rounded-lg text-white">
            <lucide-icon [name]="icons.Beaker" [size]="24" [strokeWidth]="2.5"></lucide-icon>
          </div>

          <div>
            <h1 class="text-xl font-bold text-gray-900 tracking-tight">Genomaf</h1>
          </div>
        </div>

        @if (isAuthenticated()) {
          <nav class="md:flex items-center space-x-1">
            <button
              (click)="navigateTo(isAdminZone ? '/admin' : '/home/dashboard')"
              [class]="
                'px-3 py-2 rounded-md text-sm font-medium transition-colors ' +
                (isActive(isAdminZone ? '/admin' : '/home/dashboard')
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900')
              "
            >
              {{ isAdminZone || isSuperAdmin() ? 'Back-office' : 'Tableau de bord' }}
            </button>
            @if (isAdminZone) {
              @if (canSeeLaboratories) {
                <button
                  (click)="navigateTo('/admin/laboratories')"
                  [class]="
                    'px-3 py-2 rounded-md text-sm font-medium transition-colors ' +
                    (isActive('/admin/laboratories')
                      ? 'bg-blue-50 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900')
                  "
                >
                  Laboratoires
                </button>
              }
              @if (canSeeUsers) {
                <button
                  (click)="navigateTo('/admin/users')"
                  [class]="
                    'px-3 py-2 rounded-md text-sm font-medium transition-colors ' +
                    (isActive('/admin/users')
                      ? 'bg-blue-50 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900')
                  "
                >
                  Utilisateurs
                </button>
              }
              @if (canSeeAnalysisTypes) {
                <button
                  (click)="navigateTo('/admin/analysis-types')"
                  [class]="
                    'px-3 py-2 rounded-md text-sm font-medium transition-colors ' +
                    (isActive('/admin/analysis-types')
                      ? 'bg-blue-50 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900')
                  "
                >
                  Types d'Analyse
                </button>
              }
              @if (canSeeRegistrations) {
                <button
                  (click)="navigateTo('/admin/registrations')"
                  [class]="
                    'px-3 py-2 rounded-md text-sm font-medium transition-colors ' +
                    (isActive('/admin/registrations')
                      ? 'bg-blue-50 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900')
                  "
                >
                  Inscriptions
                </button>
              }
            } @else {
              <button
                (click)="navigateTo('/home/demands')"
                [class]="
                  'px-3 py-2 rounded-md text-sm font-medium transition-colors ' +
                  (isActive('/home/demands')
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900')
                "
              >
                Suivi des demandes
              </button>
            }
          </nav>
        }
      </div>
      @if (isAuthenticated()) {
        <div class="flex items-center gap-4">
          <div class="sm:flex flex-col items-end mr-2">
            <span class="text-sm font-medium text-gray-900">{{ userName() }}</span>
            <span class="text-xs text-gray-500"
              >{{ isSuperAdmin() ? 'Super Admin' : labName() }}
              {{ isExecutor() ? '(Central)' : '' }}
            </span>
          </div>
          @if (isAdmin()) {
            <button
              (click)="navigateTo('/admin')"
              class="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
              title="Back-office (Administration)"
            >
              <lucide-icon [name]="icons.Settings" [size]="20"></lucide-icon>
            </button>
          }
          <!-- User Menu Dropdown -->
          <div class="relative #userMenuContainer">
            <button
              (click)="toggleUserMenu($event)"
              [class]="
                'p-2 rounded-full transition-colors flex items-center justify-center ' +
                (showUserMenu
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-500 hover:bg-gray-100 hover:text-gray-900')
              "
              title="Mon Compte"
            >
              <lucide-icon [name]="icons.User" [size]="20"></lucide-icon>
            </button>

            <!-- Dropdown Body -->
            @if (showUserMenu) {
              <div
                class="absolute right-0 mt-2 w-72 bg-white rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 z-50 overflow-hidden transform origin-top-right transition-all"
              >
                <!-- Header -->
                <div class="px-4 py-4 bg-gray-50 border-b border-gray-100 flex items-center gap-3">
                  <div
                    class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold border border-blue-200"
                  >
                    {{ isExecutor() ? 'E' : 'P' }}
                  </div>
                  <div>
                    <p class="text-sm font-bold text-gray-900">{{ userName() }}</p>
                    <p class="text-xs text-gray-500 truncate max-w-[180px]">{{ email() }}</p>
                  </div>
                </div>

                <!-- Menu Items -->
                <div class="py-1">
                  <button
                    (click)="openProfile()"
                    class="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-blue-700 flex items-center gap-3 transition-colors group"
                  >
                    <lucide-icon
                      [name]="icons.User"
                      [size]="16"
                      class="text-gray-400 group-hover:text-blue-600"
                    ></lucide-icon>
                    <div>
                      <span class="font-medium block">Mon Profil</span>
                      <span class="text-[10px] text-gray-400 font-normal"
                        >Infos & Mot de passe</span
                      >
                    </div>
                  </button>

                  <button
                    (click)="openInfoPage('general-conditions')"
                    class="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-blue-700 flex items-center gap-3 transition-colors group"
                  >
                    <lucide-icon
                      [name]="icons.FileText"
                      [size]="16"
                      class="text-gray-400 group-hover:text-blue-600"
                    ></lucide-icon>
                    <span class="font-medium">Conditions Générales (CGU)</span>
                  </button>

                  <button
                    (click)="openInfoPage('privacy-policy')"
                    class="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-blue-700 flex items-center gap-3 transition-colors group"
                  >
                    <lucide-icon
                      [name]="icons.Shield"
                      [size]="16"
                      class="text-gray-400 group-hover:text-blue-600"
                    ></lucide-icon>
                    <span class="font-medium">Politique de Confidentialité</span>
                  </button>

                  <button
                    (click)="openInfoPage('legal-mentions')"
                    class="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-blue-700 flex items-center gap-3 transition-colors group"
                  >
                    <lucide-icon
                      [name]="icons.FileCheck"
                      [size]="16"
                      class="text-gray-400 group-hover:text-blue-600"
                    >
                    </lucide-icon>
                    <span class="font-medium">Mentions Légales</span>
                  </button>
                </div>

                <!-- Footer: Logout -->
                <div class="border-t border-gray-100 bg-gray-50/50 p-1">
                  <button
                    (click)="handleLogout()"
                    class="w-full text-left px-3 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg flex items-center justify-center gap-2 transition-colors"
                  >
                    <lucide-icon [name]="icons.LogOut" [size]="16"></lucide-icon>
                    Déconnexion
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </header>

  <!-- Main Content -->
  <main class="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <router-outlet></router-outlet>
  </main>
</div>
